import assetPath from '/app/xinglets/network/entry-logged-out/src/components/discover-network/assets/network-image-wide-de.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')